import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { 
  ASSESSMENT_TYPE_LIST,
  ASSESSMENT_TYPE_ADD,
  ASSESSMENT_TYPE_DETAIL,
  ASSESSMENT_TYPE_UPDATE
} from '../../actions';

import {
  AssessmentTypeListSuccess,
  AssessmentTypeListError,
  AssessmentTypeAddSuccess,
  AssessmentTypeAddError,
  AssessmentTypeDetailSuccess,
  AssessmentTypeDetailError,
  AssessmentTypeUpdateSuccess,
  AssessmentTypeUpdateError
} from '../../actions';
 
export function* watchAssessmentTypeList() {
  yield takeEvery(ASSESSMENT_TYPE_LIST, onAssessmentTypeList);
}

export function* watchAssessmentTypeAdd() {
  yield takeEvery(ASSESSMENT_TYPE_ADD, onAssessmentTypeAdd);
}

export function* watchAssessmentTypeDetail() {
  yield takeEvery(ASSESSMENT_TYPE_DETAIL, onAssessmentTypeDetail);
}

export function* watchAssessmentTypeUpdate() {
  yield takeEvery(ASSESSMENT_TYPE_UPDATE, onAssessmentTypeUpdate);
}

const onAssessmentTypeListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/assessment_type/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAssessmentTypeUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/assessment_type/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onAssessmentTypeAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/assessment_type/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onAssessmentTypeDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/assessment_type/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onAssessmentTypeList(data) {
  try {
    const response = yield call(onAssessmentTypeListAsync, data.payload);
    yield put(AssessmentTypeListSuccess(response.data));
  } catch (error) {
    yield put(AssessmentTypeListError(error));
  }
}

function* onAssessmentTypeAdd(data) {
  try {
      const response = yield call(onAssessmentTypeAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AssessmentTypeAddSuccess(response.data));
  } catch (error) {
      yield put(AssessmentTypeAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onAssessmentTypeDetail(data) {
  try {
    const response = yield call(onAssessmentTypeDetailAsync, data.payload);
    yield put(AssessmentTypeDetailSuccess(response.data.data));
  } catch (error) {
    yield put(AssessmentTypeDetailError(error));
  }
}

function* onAssessmentTypeUpdate(data) {
  try {
      const response = yield call(onAssessmentTypeUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AssessmentTypeUpdateSuccess(response.data));
  } catch (error) {
      yield put(AssessmentTypeUpdateError(error));
  }
}


export default function* rootSaga() {
  yield all([
    fork(watchAssessmentTypeList),
    fork(watchAssessmentTypeAdd),
    fork(watchAssessmentTypeDetail),
    fork(watchAssessmentTypeUpdate)
  ]);
} 